import LoginCallbackIndex from '@/components/LoginCallbackIndex';

/**
 * ログインコールバック
 * @param param0
 * @returns
 */
export default function LoginCallBack() {
  return (
    <>
      <LoginCallbackIndex />
    </>
  );
}
